import { render } from "./Onboarding1.vue?vue&type=template&id=36e370d5&scoped=true"
import script from "./Onboarding1.vue?vue&type=script&lang=js"
export * from "./Onboarding1.vue?vue&type=script&lang=js"

import "./Onboarding1.vue?vue&type=style&index=0&id=36e370d5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36e370d5"

export default script